setCurrentRouteName